<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M64.0018 103.922C86.0499 103.922 103.923 86.0481 103.923 64C103.923 41.9518 86.0499 24.0783 64.0018 24.0783C41.9536 24.0783 24.0801 41.9518 24.0801 64C24.0801 86.0481 41.9536 103.922 64.0018 103.922Z"
            class="primary-stroke"
            stroke-width="3.75944"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M61.3707 72.0022L74.663 58.7099L71.9866 56.0335L61.3707 66.6495L56.0627 61.3415L53.3863 64.0179L61.3796 72.0112L61.3707 72.0022ZM64.0023 87.7382C58.5779 86.2612 54.0935 83.0657 50.5399 78.1695C46.9863 73.2643 45.2051 67.7863 45.2051 61.7264V47.3063L64.0023 40.2708L82.7995 47.3063V61.7264C82.7995 67.7863 81.0182 73.2643 77.4647 78.1695C73.9111 83.0747 69.4177 86.2612 64.0023 87.7382ZM64.0023 83.7728C68.3435 82.3944 71.9419 79.6375 74.7793 75.5021C77.6168 71.3667 79.04 66.7748 79.04 61.7175V49.8752L64.0023 44.2629L48.9645 49.8752V61.7175C48.9645 66.7748 50.3877 71.3667 53.2252 75.5021C56.0627 79.6375 59.661 82.3944 64.0023 83.7728Z"
            class="primary-fill" />
    </svg>
</template>
